export enum adminsFilterStatuses {
  active = "Active",
  inActive = "In Active"
}
